import React from 'react';

/**
 * 상세 패널 내 항목 표시
 */
function DetailItem({ label, value, bold, color }) {
  return (
    <div className="flex justify-between items-center gap-4">
      <span className="text-[13px] font-bold text-[#8b95a1] shrink-0">{label}</span>
      <span className={`text-[16px] text-right ${bold ? 'font-black' : 'font-bold'} text-[#191f28]`} style={{ color: color }}>
        {value}
      </span>
    </div>
  );
}

export default DetailItem;
